"use client";

import { useEffect } from "react";

export const REF_KEY = "smtpx-ref";
const DAYS = 90;
const CODE = /^[A-Za-z0-9]{4,24}$/;

/** Remembers an affiliate code from `?ref=CODE` for 90 days so sign-up can attach it later. */
export function RefCapture() {
  useEffect(() => {
    try {
      const ref = new URLSearchParams(window.location.search).get("ref");
      if (ref && CODE.test(ref)) localStorage.setItem(REF_KEY, JSON.stringify({ code: ref.toUpperCase(), until: Date.now() + DAYS * 86400_000 }));
    } catch {
      /* storage blocked: the code simply isn't remembered */
    }
  }, []);
  return null;
}

/** The remembered code, if still valid. */
export function storedRef(): string | null {
  try {
    const v = JSON.parse(localStorage.getItem(REF_KEY) ?? "null") as { code?: string; until?: number } | null;
    return v?.code && v.until && v.until > Date.now() && CODE.test(v.code) ? v.code : null;
  } catch {
    return null;
  }
}
